mutation RecordPolicyAcknowledgement(
  $employeeId: ID!
  $policyId: ID!
  $acknowledgedAt: ISO8601DateTime
) {
  recordPolicyAcknowledgement(
    input: {
      employeeId: $employeeId
      policyId: $policyId
      acknowledgedAt: $acknowledgedAt
    }
  ) {
    policyAcknowledgement {
      id
      version
      acknowledgedAt
    }
  }
}
